'use client'

import { FC } from 'react'
import { useLayoutData } from '@/context/LayoutDataContext'
import { Panel, PanelItem, PanelLayout } from '@/components/Panel'
import { Colour } from '@/components/constants'
import cx from 'classnames'
import styles from './styles.module.scss'
import { Logo } from '@/components/Logo'
import { Navigation } from '@/components/Navigation'

export const Header: FC = () => {
  const { header } = useLayoutData()

  return (
    <Panel
      data-testid="header"
      id="header"
      key="HeaderPanel"
      short
      layout={PanelLayout.full}
      colour={Colour.black}
      className={cx(styles.header, styles.hasBackground)}
    >
      <PanelItem className={styles.content} key="HeaderItem">
        <Logo
          src={header.fields.logo.fields.file.url}
          title={header.fields.logo.fields.title}
        />
        <Navigation className={styles.rightSide} />
      </PanelItem>
    </Panel>
  )
}
